import { useCallback } from "react";
import USER_ROLES from "../../types/UserRoles";

export const useGetUserRoleTagProps = () => {
  const getRoleTagProps = useCallback(
    (value: string): any =>
      value === USER_ROLES.PORTAL_USER ? { color: "blue" } : {},
    []
  );

  return { getRoleTagProps };
};
